import axios from 'axios'
import { URL_BACKOFFICE } from '@/configs'
import { getAuthHeader } from '@/firebase/config'

const { post } = axios

const onError = (err: any) => {
  // tslint:disable-next-line:no-console
  console.error(err)
  return false
}

export const addSupportUserInTenant = async (
  tenantName: string
): Promise<any> =>
  post(
    `${URL_BACKOFFICE}/support-user`,
    {
      tenant: tenantName,
    },
    await getAuthHeader()
  )
    .then((r: any) => r.data)
    .catch(onError)

export const removeSupportUserFromTenant = async (): Promise<boolean> =>
  axios
    .delete(`${URL_BACKOFFICE}/support-user`, await getAuthHeader())
    .then((r: any) => true)
    .catch((err: any) => false)

export default {
  addSupportUserInTenant,
  removeSupportUserFromTenant,
}
